const SERVICE_SWITCH = {
  NAME: 'service_switch',
  STATE_OPEN: '1',
  STATE_CLOSE: '-1',
  STATE_NEED_SET_CALLFORWARD: '-2'
}

const LAST_ACCOUNT_ID = 'LAST_ACCOUNT_ID'

module.exports = {
  SERVICE_SWITCH,
  LAST_ACCOUNT_ID
}



// WEBPACK FOOTER //
// ./src/utils/const.js